<template>
  <button class="btn btn-primary btn-xl d-flex justify-content-center align-items-center" style="min-width: 100px; height: 37px;">
    <span class="spinner"></span>
  </button>
</template>
<script>
export default {
  name: "LoadingButton",
};
</script>
<style scoped>
.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid var(--border);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
  display: inline-block;
  vertical-align: middle;

}



@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
